import { render, staticRenderFns } from "./PriceCalculationTable.vue?vue&type=template&id=b061e58a&scoped=true&lang=pug"
import script from "./PriceCalculationTable.vue?vue&type=script&lang=js"
export * from "./PriceCalculationTable.vue?vue&type=script&lang=js"
import style0 from "./PriceCalculationTable.vue?vue&type=style&index=0&id=b061e58a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061e58a",
  null
  
)

export default component.exports